var _g, _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLactose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lactose",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#eaf3fa"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14609",
    "data-name": "Path 14609",
    d: "M145.075,403.833l-11.42,11.308v53.214h29.819V415.363l-11.527-11.53Z",
    transform: "translate(-95.26 -380.499)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14610",
    "data-name": "Path 14610",
    d: "M153.051,402.343a1.835,1.835,0,0,0-1.3-.537h-6.872a1.837,1.837,0,0,0-1.291.531l-11.42,11.308a1.837,1.837,0,0,0-.543,1.3v53.214A1.834,1.834,0,0,0,133.462,470h29.819a1.834,1.834,0,0,0,1.835-1.834V415.17a1.837,1.837,0,0,0-.537-1.3Zm8.4,63.985H135.3V415.712l10.34-10.238h5.357l10.454,10.454Z",
    transform: "translate(-95.067 -380.305)",
    fill: "#b6cbe0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14612",
    "data-name": "Path 14612",
    d: "M146.927,402.4l-2.594,2.593,10.991,10.993V468.22h3.668V415.226a1.833,1.833,0,0,0-.537-1.3Z",
    transform: "translate(-96.28 -380.362)",
    fill: "#b6cbe0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2246",
    "data-name": "Rectangle 2246",
    width: 29.819,
    height: 3.668,
    transform: "translate(38.395 32.809)",
    fill: "#b6cbe0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLactose);
export default __webpack_public_path__ + "static/media/Lactose.d6f06e9b0b69d8dc4fd99497c0cfd3f7.svg";
export { ForwardRef as ReactComponent };